// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb":"breadcrumb-module--breadcrumb--1j4L8","separator":"breadcrumb-module--separator--2_3t0"};